import React, { useEffect, useState, useRef } from "react";
import { Menu } from "lucide-react";
import { Outlet } from "react-router-dom";
import DashboardRightSidebar from "../components/dashboard/DashboardRightSidebar";
import DashboardLeftSidebar from "../components/dashboard/DashboardLeftSidebar";


const CreateSurveyLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchActiveTab, setSearchActiveTab] = useState("all");

  useEffect(() => {
    document.body.classList.add("dashboard-layout-active");
    return () => document.body.classList.remove("dashboard-layout-active");
  }, []);


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1200 && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarOpen]);

  return (
    <div className="dashboard-page"> 
      <section className="pt60px">
        <div className="container-fluid">
          <div className="row dashboard-layout align-items-start">
            
            <div
              className={`dashboard-sidebar-backdrop ${sidebarOpen ? "show" : ""}`}
              onClick={() => setSidebarOpen(false)}
            ></div>


          
              <DashboardLeftSidebar
                activeTab={searchActiveTab}
                sidebarOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
              />
           

            <div className="col-xl-6 col-md-8 col-12 middlecenterbox">
                <div className="dashboard-sidebar-trigger d-xl-none mb-4">
                    <button
                        type="button"
                        className="btn btn-dark ft-15 fw-600 d-flex align-items-center gap-2"
                        onClick={() => setSidebarOpen(true)}
                    >
                    <Menu size={18} /> 
                        <span>Open Profile</span>
                    </button>
                </div>


                <Outlet context={{ setSidebarOpen, setSearchActiveTab, }} />


            </div>


         
            <DashboardRightSidebar />
           


          </div>
        </div>
      </section>
    </div>
  );
};

export default CreateSurveyLayout;
